<template>
  <div>
    <h1> Events </h1>
  </div>
</template>

<script>
export default {
  name: 'Events',
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Events.vue